<template>
  <div>
    <!-- 盒子 -->
    <div class="border_parent" v-show="iswin">
      <b-row type="flex" class="row-box" justify="center">
        <b-col cols="5">
          <div class="el-card">
            <div class="border_content">
              <h3>联系方式</h3>
              <div class="text item">电话：{{ contact.telephone }}</div>
              <div class="text item">邮箱：{{ contact.email }}</div>
              <div class="text item">邮编：{{ contact.code }}</div>
              <div class="text item">地址：{{ contact.address }}</div>
              <div class="text item">交通：{{ contact.traffic }}</div>
            </div>
          </div>
        </b-col>
        <b-col cols="7">
          <div class="el-card">
            <div class="border_content">
              <bmap
                class="baiduMap"
                :ak="ak"
                :center="center"
                :zoom="zoom"
                @ready="handler"
              >
                <bm-marker :position="center" :dragging="true"> </bm-marker>
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              </bmap>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="border_parent" v-show="isMo">
        <b-row class="border_top">
            <div class="text-tit">联系方式</div>
            <div class="text-titE">CONTACT US</div>
              <div class="text-m">电话：{{ contact.telephone }}</div>
              <div class="text-m">邮箱：{{ contact.email }}</div>
              <div class="text-m">邮编：{{ contact.code }}</div>
              <div class="text-m">地址：{{ contact.address }}</div>
              <div class="text-m">交通：{{ contact.traffic }}</div>
        </b-row>
        <b-row class="border_bottom">
            <bmap
                class="baiduMap-m"
                :ak="ak"
                :center="center"
                :zoom="zoom"
                @ready="handler"
              >
                <bm-marker :position="center" :dragging="true"> </bm-marker>
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
              </bmap>
        </b-row>
    </div>
  </div>
</template>

<script>
import request from "../utils/request";
import bmap from "vue-baidu-map/components/map/Map.vue";
import BmNavigation from "vue-baidu-map/components/controls/Navigation.vue"; //引入缩放控件
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import { ak } from "../config";
export default {
  name: "Contact",
  data() {
    return {
      ak: ak,
      requestUrl: {
        getPage: "/contact/page",
      },
      contact: {},
      center: {
        lng: 0,
        lat: 0,
      },
      zoom: 17,
      iswin: true,
      inMo: false,
    };
  },
  components: {
    bmap,
    BmNavigation,
    BmMarker,
  },
  mounted(){
    this.checkWindowWidth(); // 初始化时检查窗口大小
    window.addEventListener('resize', this.checkWindowWidth); // 监听窗口大小变化
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWindowWidth); // 在组件销毁前移除事件监听
  },
  methods: {
    checkWindowWidth() {
      if(window.innerWidth > 1000){
        this.iswin=true;
        this.isMo=false;
      }else{
        this.iswin=false;
        this.isMo=true;
      }
    },
    // 获取数据
    async handler({ map }) {
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      await request
        .get(this.requestUrl.getPage, {
          params: {
            pageNum: 1,
            pageSize: 1,
          },
        })
        .then((res) => {
          if (res.code === "200") {
            if (res.data.records.length) {
              this.contact = res.data.records[0];
              this.center.lng = this.contact.longitude;
              this.center.lat = this.contact.latitude;
            }
          } else {
            this.$message.error("获取失败");
          }
        });
    },
  },
};
</script>

<style scoped>
* {
  font: Helvetica, STHeiti STXihei, Microsoft JhengHei, Microsoft YaHei, Tohoma,
    Arial;
  color: #313131;
}

.border_parent {
  padding-top: 20px;
  width: 90%;
  height: 100%;
  margin: auto;
}
.border_content {
  padding: 20px 10%;
  width: 80%;
  height: calc(100% - 40px);
}
.border_bottom{
height: 15rem;
margin-top: 1rem;
}
.text {
  font-size: 1em;
}

.item {
  padding: 18px 0;
}
.text-tit{
text-align: left;
font-size: 25px;
font-weight: bold;
color: #011e4b;
}
.text-titE{
  height: 3rem;
text-align: left;
font-size: 18px;
font-weight: bold;
color: #686a6b;
}


.text-m{
  text-align: left;
  height: 1.6rem;
font-size: 15px;
margin-bottom: 5px;
font-weight: bold;
}

.row-box {
  display: flex;
  flex-flow: wrap;
}
.row-box .el-card {
  min-width: 100%;
  height: 100%;
  border: 0px;
}
.baiduMap {
  width: 100%;
  height: 100%;
}
.baiduMap-m {
  width: 100%;
  height: 100%;
}

/* 去除百度地图下方的角标 */
div/deep/.BMap_cpyCtrl {
  display: none !important;
}

div/deep/.anchorBL {
  display: none !important;
}
</style>